import { defineStore } from "pinia";

export const usePageStore = defineStore(
  "pageStore",
  () => {

    const showSearchBar = ref(false);
    function setShowSearchBar(value: boolean) {
      showSearchBar.value = value;
    }

    const tituloPagina = ref('')
    function setTituloPagina(newTituloPagina: string) {
      tituloPagina.value = newTituloPagina;
    }
    const layout = ref("main");
    // const getLayout = computed(() => layout.value);
    function setLayout(newLayout: string) {
      layout.value = newLayout;
    }

    const authenticated = ref(false);

    function setAuthStatus(newStatus: boolean) {
      authenticated.value = newStatus;
    }

    const currentPage = ref("home");
    function setCurrentPage(newPage: string) {
      currentPage.value = newPage;
    }

    const companyName = ref("");
    function setCompanyName(newCompany: string) {
      companyName.value = newCompany;
    }

    const currentOptionName = ref("");
    function setCurrentOptionName(newOptionName: string) {
      currentOptionName.value = newOptionName;
    }

    const previousPage = ref("home");
    function setPreviousPage(page: string) {
      previousPage.value = page;
    }

    const maximized = ref(true)
    function setMaximized(value: boolean) {
      maximized.value = value;
    }

    function isCollector() {
      return layout.value === "collector";
    }

    return {
      layout,
      setLayout,
      authenticated,
      setAuthStatus,
      currentPage,
      setCurrentPage,
      previousPage,
      setPreviousPage,
      currentOptionName,
      setCurrentOptionName,
      companyName,
      setCompanyName,
      showSearchBar,
      setShowSearchBar,
      maximized,
      setMaximized,
      tituloPagina,
      setTituloPagina,
      isCollector
    };
  },
  {

    persist: {
      storage: sessionStorage,
    },

  }
);

// if (import.meta.hot) {
//   import.meta.hot.accept(acceptHMRUpdate(usePageStore, import.meta.hot));
// }
